'use client';

import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface WalkthroughControlsProps {
    stepIndex: number;
    setStepIndex: React.Dispatch<React.SetStateAction<number>>;
    totalSteps: number;
}

export default function WalkthroughControls({
    stepIndex,
    setStepIndex,
    totalSteps,
}: WalkthroughControlsProps) {
    const canPrev = stepIndex > 0;
    const canNext = stepIndex < Math.max(0, totalSteps - 1);

    const [mounted, setMounted] = useState(false);
    useEffect(() => setMounted(true), []);

    const bar = totalSteps > 0 && (
        <div className="fixed bottom-0 left-0 right-0 z-[1000] border-t-[0.5px] border-line bg-white px-6 py-3 shadow-[0_-4px_12px_rgba(0,0,0,0.05)]">
            <div className="mb-2 flex items-center justify-between">
                <div className="text-[13px] font-medium text-muted">
                    Step {stepIndex + 1} of {totalSteps}
                </div>
                <div className="flex gap-2">
                    <button
                        type="button"
                        onClick={() => setStepIndex((s) => Math.max(0, s - 1))}
                        disabled={!canPrev}
                    >
                        ← Prev
                    </button>
                    <button
                        type="button"
                        onClick={() => setStepIndex((s) => Math.min(totalSteps - 1, s + 1))}
                        disabled={!canNext}
                    >
                        Next →
                    </button>
                    <button
                        type="button"
                        onClick={() => setStepIndex(totalSteps - 1)}
                        disabled={stepIndex >= totalSteps - 1}
                    >
                        Reveal full answer
                    </button>
                </div>
            </div>
            <div className="h-1 overflow-hidden rounded-full bg-subtle" aria-hidden="true">
                <div
                    className="h-full bg-purple transition-[width] duration-300 ease-out"
                    style={{ width: `${Math.round(((stepIndex + 1) / totalSteps) * 100)}%` }}
                />
            </div>
        </div>
    );

    return <>{mounted && bar && createPortal(bar, document.body)}</>;
}
